import { Modal } from "@mui/material";
// library
import classNames from "classnames";
import { useState } from "react";
import { useTranslation } from "react-i18next";

// components
import SaveSlider from "../../../../components/contract/saveSlider";
// styles
import styles from "./formHeadingContract.module.scss";

export interface IFormHeadingProps {
  smallScreen?: boolean;
}

const FormHeadingContract = (props: IFormHeadingProps) => {
  const { t } = useTranslation();
  const { smallScreen } = props;
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <>
      <div
        className={
          smallScreen
            ? styles["container"]
            : styles["container"] + " " + styles["hide-small"]
        }>
        <h1 className={styles.title}>
          <span className={styles.titleColor}>
            {t("lbl_title_contract_waffy")}
          </span>
          {t("lbl_title_contract")}
        </h1>
        <div className={styles.subtitleContainer}>
          <p
            className={classNames(
              styles.formSubtitle,
              "subtitle",
              "subtitle1"
            )}>
            {t("lbl_sub_title_contract")}
            <span
              className={styles["subtitle_link"]}
              onClick={() => setModalVisible(true)}>
              {t("lbl_sub_title_contract_link")}
            </span>
          </p>
        </div>
        <p className={classNames(styles["workWith"], "subtitle1")}>
          {t("lbl_sub_title_contract_work_with")}
        </p>
        <img
          src="/assets/images/svg/logoHarage.svg"
          className={styles["logoHarage"]}
        />
      </div>
      <Modal
        open={modalVisible}
        onClose={() => {
          setModalVisible(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className={styles.modal_container}>
        <div className={styles.save_slider_container}>
          <SaveSlider onClose={() => setModalVisible(false)} />
        </div>
      </Modal>
    </>
  );
};

export default FormHeadingContract;
